import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";
/* This is the custom StimulusReflex controller for the Conge Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
  /*
   * Regular Stimulus lifecycle methods
   * Learn more at: https://stimulusjs.org/reference/lifecycle-callbacks
   *
   * If you intend to use this controller as a regular stimulus controller as well,
   * make sure any Stimulus lifecycle methods overridden in ApplicationController call super.
   *
   * Important:
   * By default, StimulusReflex overrides the -connect- method so make sure you
   * call super if you intend to do anything else when this controller connects.
   */
  static targets = ["hm0_output"];
  static values = {
    currentApp: String,
    recordId: String,
    urlSolution: String,
    filtertype: String,
  };
  connect() {
    console.log("Contrats JS en cours ...");
    super.connect();
    // add your code here, if applicable

    if ($("#search").length && $("#quick_sort").length) {
      //on est sur la vue list
      this.rerender();
      (function ($) {
        $.each(["show", "hide"], function (i, ev) {
          var el = $.fn[ev];
          $.fn[ev] = function () {
            this.trigger(ev);
            return el.apply(this, arguments);
          };
        });
      })(jQuery);
      $("#spinner").on("show", function () {
        $("#total_entries").hide();
      });
      $("#spinner").on("hide", function () {
        $("#total_entries").show();
      });

      this.handleSidebarScroll("contrat_");
    }

    if (
      $("#partial-avenants-content").length &&
      $("#partial-avenants-content").text().trim() == "Chargement en cours ..."
    ) {
      setTimeout(() => this.contrat_avenants(), 300);
    }

    if (
      $("#partial-bons_de_commandes-content").length &&
      $("#partial-bons_de_commandes-content").text().trim() ==
        "Chargement en cours ..."
    ) {
      setTimeout(() => this.contrat_bons_de_commandes(), 300);
    }

  }

  contrat_avenants() {
    if (this.currentAppValue && this.recordIdValue) {
      let url =
        window.location.origin +
        "/" +
        this.currentAppValue +
        "/contrats/show_ajax_for_hm_contrat_avenants?contrat_id=" +
        this.recordIdValue +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-avenants-content").html("");
          $("#partial-avenants-content").html(text);
          $("#partial-avenants-badge").html(
            "(" +
              $(".show_ajax_for_hm_contrats >tbody >tr:not(.no_record)")
                .length +
              ")"
          );
        })
      );
    }
  }

  contrat_bons_de_commandes() {
    if (this.currentAppValue && this.recordIdValue) {
      let url =
        window.location.origin +
        "/" +
        this.currentAppValue +
        "/contrats/show_ajax_for_hm_contrat_bons_de_commandes?contrat_id=" +
        this.recordIdValue +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-bons_de_commandes-content").html("");
          $("#partial-bons_de_commandes-content").html(text);
          $("#partial-bons_de_commandes-badge").html(
            "(" +
              $(
                ".show_ajax_for_hm_commandes_liees >tbody >tr:not(.no_record)"
              ).length +
              ")"
          );
        })
      );
    }
  }
 
}
